import { Radio } from 'antd';
import React from 'react';

export const LCRadio = props => 
    <Radio {...props}>{props.children}</Radio>;
